
import { getToken } from 'firebase/messaging'
import env from '@/api/env';
import store from '@/store/index';
import axios from 'axios';
import auth from '@/api/auth';
import firebase from '@/api/firebase';
import papi from '@/api/papi';

export default {

	async init() {

		this.jwt = await auth.getCredentials();

		if(!this.jwt)
		{
			//redirect will happen, just exit
			return;
		}

		const { messaging } = firebase.instance();

		const notificationsGranted = await store.dispatch('notifications/notificationsGranted')
		const device = store.getters['settings/value']('deviceId');
		const type = 'firebase';
		const guid = store.getters['user/id'];

		if (notificationsGranted && device && guid) {
			const token = await getToken(messaging);

			if (papi.isCamelot) {
				await this.post(`https://api${env.suffix()}.k4connect.com/v4/service/my/token`, { token, device }, { headers: { authorization: `Bearer ${this.jwt}` } });
			} else {
				await this.post(`${env.sso()}/pushtoken`, { token, device, type, credentials: { password: this.jwt, guid } });
			}
		} else {
			console.log('notification requirements unmet')
		}
	},


	async post(url, body, options = {}) {
		let response;

		try {
			if (papi.isCamelot) {
				response = await axios.post(url, body, options);
			} else {
				response = await axios.post(url, body);
			}
			
		} catch (e) {
			console.log(e)
			throw e;
		}
		return response;

	},

}